import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PLAYERS_IN_DESK = 12;
export const defaultAvatar = "img/defaultAvatar.png";
export var ETeam;
(function (ETeam) {
    ETeam["MAFIA"] = "MAFIA";
    ETeam["CIVILIANS"] = "CIVILIANS";
    ETeam["FOOLS"] = "FOOLS";
    ETeam["ANARCHIST"] = "ANARCHIST";
})(ETeam || (ETeam = {}));
export const TeamName = (team) => {
    switch (team) {
        case ETeam.CIVILIANS:
            return "Мирные";
        case ETeam.MAFIA:
            return "Мафия";
        case ETeam.FOOLS:
            return "Дурак";
        case ETeam.ANARCHIST:
            return "Анархист";
    }
    return "";
};
export var TMatchResultCase;
(function (TMatchResultCase) {
    TMatchResultCase["MAFIA_WIN"] = "MAFIA_WIN";
    TMatchResultCase["CIVILIANS_WIN"] = "CIVILIANS_WIN";
    TMatchResultCase["FOOLS_WIN"] = "FOOLS_WIN";
    TMatchResultCase["ANARCHIST_WIN"] = "ANARCHIST_WIN";
    TMatchResultCase["DRAW"] = "DRAW";
    TMatchResultCase["WEREWOLF_WIN"] = "WEREWOLF_WIN";
})(TMatchResultCase || (TMatchResultCase = {}));
export var ERoleTypes;
(function (ERoleTypes) {
    ERoleTypes["CIVILIAN"] = "CIVILIAN";
    ERoleTypes["MAFIA"] = "MAFIA";
    ERoleTypes["DON"] = "DON";
    ERoleTypes["SHERIFF"] = "SHERIFF";
    ERoleTypes["DOCTOR"] = "DOCTOR";
    ERoleTypes["LADY"] = "LADY";
    ERoleTypes["SWITCHMAN"] = "SWITCHMAN";
    ERoleTypes["BOMB"] = "BOMB";
    ERoleTypes["JAILER"] = "JAILER";
    ERoleTypes["WEREWOLF"] = "WEREWOLF";
    ERoleTypes["POISONER"] = "POISONER";
    ERoleTypes["THIEF"] = "THIEF";
    ERoleTypes["SAVIOR"] = "SAVIOR";
    ERoleTypes["HOMELESS"] = "HOMELESS";
    ERoleTypes["SPY"] = "SPY";
    ERoleTypes["CONSIGLIERE"] = "CONSIGLIERE";
    ERoleTypes["MAFIA_LADY"] = "MAFIA_LADY";
    ERoleTypes["GAG"] = "GAG";
    ERoleTypes["PSYCHO"] = "PSYCHO";
    ERoleTypes["KAMIKADZE"] = "KAMIKADZE";
    ERoleTypes["JOURNALIST"] = "JOURNALIST";
    ERoleTypes["INTRIGUER"] = "INTRIGUER";
})(ERoleTypes || (ERoleTypes = {}));
export var TPlayerMatchStatus;
(function (TPlayerMatchStatus) {
    TPlayerMatchStatus[TPlayerMatchStatus["ALIVE"] = 0] = "ALIVE";
    TPlayerMatchStatus[TPlayerMatchStatus["DEAD"] = 1] = "DEAD";
})(TPlayerMatchStatus || (TPlayerMatchStatus = {}));
export var EPaymentType;
(function (EPaymentType) {
    EPaymentType[EPaymentType["UNKNOWN"] = 0] = "UNKNOWN";
    EPaymentType[EPaymentType["FREE"] = 1] = "FREE";
    EPaymentType[EPaymentType["BOT"] = 2] = "BOT";
    EPaymentType[EPaymentType["WIRE_TRANSFER"] = 3] = "WIRE_TRANSFER";
    EPaymentType[EPaymentType["CASH"] = 4] = "CASH";
    EPaymentType[EPaymentType["PAID_BY_OTHER_PLAYER"] = 5] = "PAID_BY_OTHER_PLAYER";
    EPaymentType[EPaymentType["POINTS"] = 6] = "POINTS";
    EPaymentType[EPaymentType["SUBSCRIPTION"] = 7] = "SUBSCRIPTION";
})(EPaymentType || (EPaymentType = {}));
export const getPaymentString = (p) => {
    switch (p) {
        case EPaymentType.WIRE_TRANSFER:
            return "Перевод";
        case EPaymentType.BOT:
            return "Бот";
        case EPaymentType.CASH:
            return "Наличные";
        case EPaymentType.FREE:
            return "Без оплаты";
        case EPaymentType.UNKNOWN:
            return "Не выбран";
        case EPaymentType.POINTS:
            return "Баллы";
        case EPaymentType.PAID_BY_OTHER_PLAYER:
            return "Другой игрок";
        case EPaymentType.SUBSCRIPTION:
            return "Абонемент";
        default:
            return "Не выбран";
    }
};
export const getRoleString = (role) => {
    /**
     *   CIVILIAN = "CIVILIAN",
     *   MAFIA = "MAFIA",
     *   DON = "DON",
     *   SHERIFF = "SHERIFF",
     *   DOCTOR = "DOCTOR",
     *   LADY = "LADY",
     *   SWITCHMAN = "SWITCHMAN",
     *   GAG = "GAG",
     *   BOMB = "BOMB",
     *   JAILER = "JAILER",
     *   WEREWOLF = "WEREWOLF",
     *   POISONER = "POISONER",
     *   THIEF = "THIEF",
     *   SAVIOR = "SAVIOR",
     *   SPY = "SPY",
     *   CONSIGLIERE = "CONSIGLIERE",
     *   MAFIA_LADY = "MAFIA_LADY",
     *   PSYCHO = "PSYCHO",
     *   KAMIKADZE = "KAMIKADZE",
     *   HOMELESS = "HOMELESS",
     */
    const map = {
        [ERoleTypes.CIVILIAN]: "Мирный",
        [ERoleTypes.DON]: "Мирный",
        [ERoleTypes.MAFIA]: "Мирный",
        [ERoleTypes.MAFIA_LADY]: "Краля",
        [ERoleTypes.CONSIGLIERE]: "Мирный",
        [ERoleTypes.SHERIFF]: "Мирный",
        [ERoleTypes.DOCTOR]: "Мирный",
        [ERoleTypes.LADY]: "Мирный",
        [ERoleTypes.PSYCHO]: "Мирный",
        [ERoleTypes.INTRIGUER]: "Мирный",
    };
    switch (role) {
        case ERoleTypes.CIVILIAN:
            return "Мирный";
        case ERoleTypes.MAFIA:
            return "Мафия";
        case ERoleTypes.DON:
            return "Дон";
        case ERoleTypes.SHERIFF:
            return "Шериф";
        case ERoleTypes.DOCTOR:
            return "Доктор";
        case ERoleTypes.PSYCHO:
            return "Анархист";
        case ERoleTypes.LADY:
            return "Куртизанка";
        case ERoleTypes.MAFIA_LADY:
            return "Краля";
        case ERoleTypes.GAG:
            return "Затычка";
        case ERoleTypes.SWITCHMAN:
            return "Стрелочник";
        case ERoleTypes.BOMB:
            return "Бомба";
        case ERoleTypes.JAILER:
            return "Тюремщик";
        case ERoleTypes.WEREWOLF:
            return "Оборотень";
        case ERoleTypes.KAMIKADZE:
            return "Камикадзе";
        case ERoleTypes.CONSIGLIERE:
            return "Консильери";
        case ERoleTypes.INTRIGUER:
            return "Интриган";
        case ERoleTypes.THIEF:
            return "Вор";
        case ERoleTypes.HOMELESS:
            return "Бродяга";
        case ERoleTypes.SPY:
            return "Шпион";
        default:
            return "Не удалось определить роль";
    }
};
// eslint-disable-next-line consistent-return
export const getRoleNightActionName = (role) => {
    // eslint-disable-next-line default-case
    switch (role) {
        case ERoleTypes.MAFIA:
            return "Убить";
        case ERoleTypes.DON:
            return "Заблокировать";
        case ERoleTypes.WEREWOLF:
            return "Убить";
        case ERoleTypes.SHERIFF:
            return "Проверить";
        case ERoleTypes.DOCTOR:
            return "Вылечить";
        case ERoleTypes.LADY:
            return "Навестить";
        case ERoleTypes.GAG:
            return "Заткнуть";
        case ERoleTypes.SWITCHMAN:
            return "Убить";
        case ERoleTypes.BOMB:
            return "Заминировать";
        case ERoleTypes.PSYCHO:
            return "Убить";
        case ERoleTypes.JAILER:
            return "Посадить в тюрьму";
        case ERoleTypes.MAFIA_LADY:
            return "Защитить";
        case ERoleTypes.INTRIGUER:
            return "Очернить";
        case ERoleTypes.CONSIGLIERE:
        case ERoleTypes.SPY:
            return "Узнать роль";
        case ERoleTypes.THIEF:
            return "Украсть роль";
    }
};
// eslint-disable-next-line consistent-return
export const getRoleNightActionColor = (role) => {
    // eslint-disable-next-line default-case
    switch (role) {
        case ERoleTypes.MAFIA:
            return "#CC8181";
        case ERoleTypes.DON:
            return "#CC8181";
        case ERoleTypes.WEREWOLF:
            return "#CC8181";
        case ERoleTypes.SHERIFF:
            return "#81CC96";
        case ERoleTypes.DOCTOR:
            return "#81CC96";
        case ERoleTypes.LADY:
            return "#81CC96";
        case ERoleTypes.GAG:
            return "#CC8181";
        case ERoleTypes.SWITCHMAN:
            return "#CC8181";
        case ERoleTypes.BOMB:
            return "#CC8181";
        case ERoleTypes.JAILER:
            return "#81CC96";
    }
};
export const getPhaseEventDescription = (type) => {
    switch (type) {
        case "KILL":
        case "VOTES_KILL":
        case "EXPLODE":
        case "FAMILY_KILL":
            return { name: "Убит", color: "red", icon: "Cross.svg" };
        case "REVOKE_IMMUNITY":
            return {
                name: (_jsxs("span", { children: ["\u0418\u043C\u043C\u0443\u043D\u0438\u0442\u0435\u0442", _jsx("br", {}), "\u0430\u043D\u043D\u0443\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F"] })),
                color: "green",
                icon: "RemovedShield.svg",
            };
        case "MAKE_SILENT":
            return {
                name: (_jsxs("span", { children: ["\u041F\u043E\u043B\u0443\u0447\u0430\u0435\u0442", _jsx("br", {}), "\u0437\u0430\u0442\u044B\u0447\u043A\u0443"] })),
                color: "green",
                icon: "Silence.svg",
            };
        case "JAILER_ARREST":
            return {
                name: (_jsxs("span", { children: ["\u0421\u0430\u0434\u0438\u0442\u0441\u044F", _jsx("br", {}), "\u0432 \u0442\u044E\u0440\u044C\u043C\u0443"] })),
                color: "green",
                icon: "LockClose.svg",
            };
        case "RELEASE_FROM_PRISON":
            return {
                name: (_jsxs("span", { children: ["\u0412\u044B\u0445\u043E\u0434\u0438\u0442", _jsx("br", {}), "\u0438\u0437 \u0442\u044E\u0440\u044C\u043C\u044B"] })),
                color: "green",
                icon: "LockOpen.svg",
            };
        case "SAVED_BY_LADY":
            return { name: "Спасён спасителем", color: "green", icon: "Lady.svg" };
        case "TECH_KILL":
            return {
                name: (_jsxs("span", { children: ["\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439", _jsx("br", {}), "\u0442\u0440\u0443\u043F"] })),
                color: "red",
                icon: "Cross.svg",
            };
        default:
            return { name: "", color: "", icon: "" };
    }
};
export var EEventPlayerStatus;
(function (EEventPlayerStatus) {
    EEventPlayerStatus[EEventPlayerStatus["ACTIVE"] = 0] = "ACTIVE";
    EEventPlayerStatus[EEventPlayerStatus["CANCELLED"] = 1] = "CANCELLED";
})(EEventPlayerStatus || (EEventPlayerStatus = {}));
export var ERoundDirection;
(function (ERoundDirection) {
    ERoundDirection["POSITIVE"] = "POSITIVE";
    ERoundDirection["NEGATIVE"] = "NEGATIVE";
})(ERoundDirection || (ERoundDirection = {}));
export var EPlayerGameStateKeys;
(function (EPlayerGameStateKeys) {
    EPlayerGameStateKeys["CAN_VOTE"] = "canVote";
    EPlayerGameStateKeys["IMMUNITY"] = "immunity";
    EPlayerGameStateKeys["MUTED"] = "muted";
    EPlayerGameStateKeys["MINED_BY"] = "minedBy";
    EPlayerGameStateKeys["IMPRISONED_BY"] = "imprisonedBy";
    EPlayerGameStateKeys["PROTECTED_BY_LADY"] = "protectedByLady";
})(EPlayerGameStateKeys || (EPlayerGameStateKeys = {}));
export var EPlayerGameStateKeysPublic;
(function (EPlayerGameStateKeysPublic) {
    EPlayerGameStateKeysPublic["MUTED"] = "muted";
    EPlayerGameStateKeysPublic["IMPRISONED_BY"] = "imprisonedBy";
    EPlayerGameStateKeysPublic["IMMUNITY"] = "immunity";
})(EPlayerGameStateKeysPublic || (EPlayerGameStateKeysPublic = {}));
export var EPlayerGameStateKeysPrivate;
(function (EPlayerGameStateKeysPrivate) {
    EPlayerGameStateKeysPrivate["MINED_BY"] = "minedBy";
    EPlayerGameStateKeysPrivate["PROTECTED_BY_LADY"] = "protectedByLady";
})(EPlayerGameStateKeysPrivate || (EPlayerGameStateKeysPrivate = {}));
// затычка и тюрьма публично
// остальные скрыть/показать
export const getPlayerGameStateString = (state, players) => {
    const out = {};
    out[EPlayerGameStateKeys.IMMUNITY] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.IMMUNITY]) && "Иммунитет") || "";
    out[EPlayerGameStateKeys.MUTED] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.MUTED]) && "Затычка") || "";
    out[EPlayerGameStateKeys.MINED_BY] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.MINED_BY]) && `Заминирован`) || "";
    out[EPlayerGameStateKeys.IMPRISONED_BY] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.IMPRISONED_BY]) && "В тюрьме") || "";
    out[EPlayerGameStateKeys.PROTECTED_BY_LADY] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.PROTECTED_BY_LADY]) &&
            `Защищен Куртизанкой`) ||
            "";
    return out;
};
var Position;
(function (Position) {
    Position[Position["BOTTOM_ROW_X"] = 373] = "BOTTOM_ROW_X";
    Position[Position["TOP_ROW_X"] = -66] = "TOP_ROW_X";
    Position[Position["START_Y_POSITION"] = 180] = "START_Y_POSITION";
    Position[Position["STEP_BY_Y"] = 155] = "STEP_BY_Y";
})(Position || (Position = {}));
const getPositionY = (num) => Position.START_Y_POSITION + num * Position.STEP_BY_Y;
export const positions = {
    "0": { x: 70, y: 16 },
    "1": { x: 257, y: 16 },
    "2": { x: Position.BOTTOM_ROW_X, y: getPositionY(0) },
    "3": { x: Position.BOTTOM_ROW_X, y: getPositionY(1) },
    "4": { x: Position.BOTTOM_ROW_X, y: getPositionY(2) },
    "5": { x: Position.BOTTOM_ROW_X, y: getPositionY(3) },
    "6": { x: Position.BOTTOM_ROW_X, y: getPositionY(4) },
    "7": { x: Position.BOTTOM_ROW_X, y: getPositionY(5) },
    "8": { x: Position.BOTTOM_ROW_X, y: getPositionY(6) },
    "9": { x: Position.BOTTOM_ROW_X, y: getPositionY(7) },
    "10": { x: Position.BOTTOM_ROW_X, y: getPositionY(8) },
    "11": { x: Position.BOTTOM_ROW_X, y: getPositionY(9) },
    "12": { x: Position.BOTTOM_ROW_X, y: getPositionY(10) },
    "13": { x: 150, y: 1860 },
    "14": { x: Position.TOP_ROW_X, y: getPositionY(10) },
    "15": { x: Position.TOP_ROW_X, y: getPositionY(9) },
    "16": { x: Position.TOP_ROW_X, y: getPositionY(8) },
    "17": { x: Position.TOP_ROW_X, y: getPositionY(7) },
    "18": { x: Position.TOP_ROW_X, y: getPositionY(6) },
    "19": { x: Position.TOP_ROW_X, y: getPositionY(5) },
    "20": { x: Position.TOP_ROW_X, y: getPositionY(4) },
    "21": { x: Position.TOP_ROW_X, y: getPositionY(3) },
    "22": { x: Position.TOP_ROW_X, y: getPositionY(2) },
    "23": { x: Position.TOP_ROW_X, y: getPositionY(1) },
    "24": { x: Position.TOP_ROW_X, y: getPositionY(0) },
};
